import { FormConfig, Validator } from '@topdanmark-onlinesolutions/claim-form-types';
import { getElementFromElementId } from './getElementFromElementId';

type LengthObject = {
    maxLength?: number;
    minLength?: number;
};

export const getMinMaxLength = (formConfig: FormConfig | undefined, elementId: string) => {
    const lengthObject: LengthObject = {
        minLength: undefined,
        maxLength: undefined
    };

    if (formConfig === undefined) {
        return lengthObject;
    }

    const element = getElementFromElementId(formConfig, elementId);
    const { validators } = element;

    validators.forEach((validator: Validator) => {
        const { type } = validator;

        if (type === 'maxLength') {
            const { maxLength } = validator;

            lengthObject.maxLength = maxLength;
        }

        if (type === 'minLength') {
            const { minLength } = validator;

            lengthObject.minLength = minLength;
        }

        if (type === 'exactLength') {
            const { length } = validator;

            lengthObject.minLength = length;
            lengthObject.maxLength = length;
        }
    });

    return lengthObject;
};
